import React from 'react';
import styled from 'styled-components';
import { List as AntdList } from 'antd';
import { ListProps, ListItemProps, ListItemMetaProps } from 'antd/lib/list';

const BaseList: React.FC<ListProps<any>> = props => <AntdList {...props} />;
const BaseListItem: React.FC<ListItemProps> = props => (
  <AntdList.Item {...props} />
);
const BaseListItemMeta: React.FC<ListItemMetaProps> = props => (
  <AntdList.Item.Meta {...props} />
);

export const List = styled(BaseList)``;
export const ListItem = styled(BaseListItem)``;
export const ListItemMeta = styled(BaseListItemMeta)``;
export {
  AppointmentItemActions,
  AppointmentListItem,
  BuyerAppointmentListItem,
  ListingListItem,
} from './ListItems';
